finalCost